/* Copyright (c) 2023 VMware, Inc. All rights reserved. VMware Confidential */
import { Event } from "@app/services/dispatcher/events/event";

export class TitleUpdateEvent extends Event {
    public static ID: string = "TITLE_UPDATE";
    public vlrEnabled: boolean = false;

    constructor(vlrEnabled: boolean) {
        super(TitleUpdateEvent.ID);
        this.vlrEnabled = vlrEnabled;
    }
}
